
namespace RioERP.Users {

    @Serenity.Decorators.registerClass()
    export class TeachersDialog extends Serenity.EntityDialog<TeachersRow, any> {
        protected getFormKey() { return TeachersForm.formKey; }
        protected getIdProperty() { return TeachersRow.idProperty; }
        protected getLocalTextPrefix() { return TeachersRow.localTextPrefix; }
        protected getNameProperty() { return TeachersRow.nameProperty; }
        protected getService() { return TeachersService.baseUrl; }
        protected getDeletePermission() { return TeachersRow.deletePermission; }
        protected getInsertPermission() { return TeachersRow.insertPermission; }
        protected getUpdatePermission() { return TeachersRow.updatePermission; }

        protected form = new TeachersForm(this.idPrefix);
        constructor() {
            super();
            if (this.isNew()) {
                this.form.Gstin.getGridField().toggle(false);
                this.form.Pan.getGridField().toggle(false);
                this.form.GstCertificate.getGridField().toggle(false);

                this.form.IsGstApplicable.change(e => {
                    if (this.form.IsGstApplicable.value == false) {
                        this.form.Gstin.getGridField().toggle(false);
                        this.form.Pan.getGridField().toggle(false);
                        this.form.GstCertificate.getGridField().toggle(false);
                    }
                    else {
                        this.form.Gstin.getGridField().toggle(true);
                        this.form.Pan.getGridField().toggle(true);
                        this.form.GstCertificate.getGridField().toggle(true);
                    }
                }
                );
            }
        }
    }
}